import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function PortField({ value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateNotEmpty(value, 'port');
        return () => validationService.cleanValidation('port');
    }, [value]);

    const [touched, setTouched] = useState(false);

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="port">Port <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="port"
                    value={value}
                    disabled={disabled}
                    placeholder={'22 is used as the default'}
                    onFocus={() => setTouched(true)}
                    onChange={disabled ? null : event => onChange(event.target.value)} />
                {/* onChange={event => onChange(event.target.value)}/> */}
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PortField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.port
    }
}

export default connect(mapStateToProps)(PortField);
